export default {"src":"/_next/static/media/ik_logo_in_footer.a0674ca4.svg","height":18,"width":86,"blurWidth":0,"blurHeight":0};